import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const FacebookIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M22,20.5 L22.8,15.8 L18.3,15.8 L18.3,12.8 C18.3,11.5 18.9,10.3 20.9,10.3 L23,10.3 L23,6.3 C23,6.3 21.1,6 19.3,6 C15.6,6 13.2,8.2 13.2,12.3 L13.2,15.8 L9,15.8 L9,20.5 L13.2,20.5 L13.2,31.8 C14.8572229,32.0509147 16.5427771,32.0509147 18.2,31.8 L18.2,20.5 L22.1,20.5"
        data-testid="icon-facebook"
        fill="#ffffff"
        className={styles.white}
      />
    </Icon>
  )
}
